// products container directive
finderApp.directive('productsContainer', function (finderBasePath) {
    return {
        restrict: 'E',
        templateUrl: finderBasePath + 'template/productsContainer_v2.html'
    }
});
